import { create } from 'zustand';

interface ReportProgressState {
  processed: number;
  total: number;
  success: number;
  failed: number;
  isActive: boolean;
  updateFromEvent: (event: { processed: number; total: number; success: number; failed: number; type: string }) => void;
  reset: () => void;
  complete: () => void;
}

const useReportProgressStore = create<ReportProgressState>()((set) => ({
  processed: 0,
  total: 0,
  success: 0,
  failed: 0,
  isActive: false,

  updateFromEvent: (event) =>
    set({
      processed: event.processed,
      total: event.total,
      success: event.success,
      failed: event.failed,
      isActive: event.type !== 'complete',
    }),

  reset: () => set({ processed: 0, total: 0, success: 0, failed: 0, isActive: false }),

  complete: () => set({ isActive: false }),
}));

export const useReportProgress = () => useReportProgressStore();

export default useReportProgressStore;
